import { Box, Typography } from '@material-ui/core';
import useStyles from './checkCode.style';

export function CheckCode(props: Props) {
  const { label, code, hasTurboUrgency = false } = props;
  const styles = useStyles({ hasTurboUrgency });

  return (
    <Box
      className={styles.checkCodeContainer}
      display='flex'
      alignItems='center'
      justifyContent='center'
      padding='0.25rem 0.75rem'
    >
      <Typography className={styles.checkCode}>
        {label}: {code}
      </Typography>
    </Box>
  );
}

interface Props {
  label: string;
  code: string;
  hasTurboUrgency?: boolean;
}
